import { createContext } from 'react';

const partnerInstitutionContext = createContext();

export default partnerInstitutionContext;
